import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class FactoringBuntService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 1956
     * @datataskName sp_ws_p2_w_factoringbunt_get
     * @param params the keyno of the bunt to get.
     * @returns promise containing the factoring bunt get.
     */
    public async getFactoringBunt(params: GetFactoringBuntParams): Promise<FactoringBuntGet> {
        return (await this.datatask.Post(1956, params))[0];
    }

    /**
     * @datatask 1959
     * @datataskName sp_ws_p2_w_factoringbunt_export
     * @param params the bunt to export.
     * @returns promise containing file contents of the factoring bunt.
     */
    public async exportFactoringBunt(params: FactoringBuntGet): Promise<ExportFactoringBuntResponse> {
        return (await this.datatask.Post(1959, params))[0];
    }

    /**
     * @datatask 1960
     * @datataskName sp_ws_p2_w_factoringbunt_save
     * @param params the bunt to save
     * @returns promise containing validation.
     */
    public async saveFactoringBunt(params: GetFactoringBuntParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(1960, params))[0];
    }
}

export interface GetFactoringBuntParams {
    factoringbunt_keyno: string;
}

export interface FactoringBuntGet {
    factoringbunt_keyno: string;
    bunt_datetime: string;
    modified_datetime: string;
    sent_datetime: string;
    bunttype: string;
    amount: string;
    sent_ok: string;
    registered_of: string;
    modified_of: string;
    number_of_invoices: string;
    company_name: string;
    bunt_valuta_id: string;
    view_id: string;
    p2_datatask_keyno: number;
}

export interface ExportFactoringBuntResponse extends ErrorMessageResponse, Record<string, string> {}
